import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full px-6" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-center py-8 text-black"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center py-8 text-black"
}
const _hoisted_7 = {
  key: 0,
  class: "py-10 text-center text-black"
}
const _hoisted_8 = {
  key: 1,
  class: "p-4 bg-red-50 text-red-700 rounded"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "border rounded overflow-hidden preview-container" }
const _hoisted_11 = ["srcdoc"]
const _hoisted_12 = {
  key: 0,
  class: "mt-6 bg-gray-50 rounded-lg p-5 border border-gray-200"
}
const _hoisted_13 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = { class: "font-semibold text-black" }
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { class: "w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center" }
const _hoisted_18 = { class: "flex items-center gap-3" }
const _hoisted_19 = { class: "font-semibold text-black" }
const _hoisted_20 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_21 = { class: "font-semibold text-black" }
const _hoisted_22 = { class: "mb-6" }
const _hoisted_23 = { class: "border-b border-gray-200" }
const _hoisted_24 = { class: "-mb-px flex space-x-8" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "space-y-6" }
const _hoisted_27 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_28 = { class: "bg-gray-50 p-4 rounded-lg" }
const _hoisted_29 = { class: "text-black" }
const _hoisted_30 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_31 = { class: "bg-gray-50 p-4 rounded-lg" }
const _hoisted_32 = { class: "text-black" }
const _hoisted_33 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_34 = { class: "bg-gray-50 p-4 rounded-lg" }
const _hoisted_35 = { class: "text-black" }
const _hoisted_36 = {
  key: 3,
  class: "space-y-4"
}
const _hoisted_37 = { class: "bg-gray-50 p-4 rounded-lg" }
const _hoisted_38 = { class: "text-black" }

import { ref, reactive, onMounted } from 'vue'
import { 
  PageHeader, 
  ActionButton, 
  ModalComp,
  PromoCodeTable,
  ReferralCodeSection,
  AddPromoModal
} from '@/components'
import type { PromoCode, CreatePromoCodeInput } from '@/types/promo'
import type { Buyer } from '@/types/buyer'
import { 
  getPromoCodes, 
  createPromoCode, 
  deletePromoCode as deletePromoCodeApi, 
  togglePromoCodeStatus as togglePromoCodeStatusApi 
} from '@/api/promoCodes'
import { getPromoEmailPreview } from '@/api/promoCodes'
import { getBuyersByVendor } from '@/api/buyers'
import { useAuthStore } from '@/stores/auth'
import { remiseLocalisationLabel } from '@/utils/remiseLocalisation'
import {useRouter} from "vue-router";

// Store d'authentification

export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCodeView',
  setup(__props) {

const authStore = useAuthStore()
const router = useRouter()
// State local
const state = reactive({
  promoCodes: [] as PromoCode[], // Données formatées
  buyers: [] as Buyer[],
  isLoading: false,
  error: null as string | null
})



const fetchPromoCodes = async () => {
  state.isLoading = true
  state.error = null
  
  try {
    // Récupérer l'ID du vendeur connecté
    const vendeurId = authStore.user?.id_vendeur
    
    if (!vendeurId) {
      state.error = 'Utilisateur non connecté'
      return
    }
    
    // Récupérer les codes promo (prioritaire) et les acheteurs (best‑effort)
    const promoCodesApi = await getPromoCodes(vendeurId)
    let buyersData: Buyer[] = []
    try {
      buyersData = await getBuyersByVendor()
    } catch (e) {
      // Ne pas bloquer l'affichage des codes promo si la récupération des acheteurs échoue
      console.warn('[PromoCode] Impossible de récupérer la liste des acheteurs, utilisation des libellés par défaut')
      buyersData = []
    }
    
    // Mapping direct comme dans les remises (plus rapide)
    state.promoCodes = promoCodesApi.map((promo: any) => {
      // Trouver l'acheteur correspondant
      const buyer = buyersData.find(
        (b) => String(b.id_acheteur) === String(promo.id_acheteur ?? ''),
      )
      const hasBuyer = promo.id_acheteur != null && Number(promo.id_acheteur) > 0
      const acheteurInfo = hasBuyer
        ? (promo.acheteurNom || buyer?.nomSociete || `Acheteur #${promo.id_acheteur}`)
        : 'Tous les acheteurs'
      
      return {
        id: promo.id_code_promo.toString(),
        code: promo.libelle || '',
        acheteur: acheteurInfo,
        idAcheteur: hasBuyer ? String(promo.id_acheteur) : null,
        buyerEmail: promo.acheteurEmail || buyer?.email || null,
        type: (promo.type === 'pourcentage' ? 'Percentage' : 'Reduction') as 'Percentage' | 'Reduction',
        montant: promo.type === 'pourcentage' ? `${promo.montant}%` : `${promo.montant}€`,
        montantMin: promo.minimum ? promo.minimum.toString() : '0',
        // Le backend peut renvoyer des nombres ou des chaînes
        localisation: remiseLocalisationLabel(promo.localisation),
        utilisation: ((promo.utilisation === 1 || promo.utilisation === '1') ? 'unique' : 'multiple') as 'unique' | 'multiple',
        actif: promo.actif ? 'activé' : 'désactivé',
        dateDebut: promo.date_debut ? new Date(promo.date_debut).toLocaleDateString('fr-FR') : 'Non définie',
        dateFin: promo.date_fin ? new Date(promo.date_fin).toLocaleDateString('fr-FR') : 'Non définie',
        dateCreation: promo.date_creation ? new Date(promo.date_creation).toLocaleDateString('fr-FR') : 'Non définie',
        // Champs additionnels persistés côté DB
        premiereCommande: !!(promo as any).premiere_commande,
        offert: !!(promo as any).offert,
        cumulable: !!(promo as any).cumulable,
        // Dates brutes pour calcul du statut
        dateDebutISO: promo.date_debut ?? null,
        dateFinISO: promo.date_fin ?? null
      }
    })
    
    if (state.promoCodes.length === 0) {
      console.debug('[PromoCode] Aucun code promo pour vendeur', vendeurId, '— payload brut:', promoCodesApi)
    }
    
    state.buyers = buyersData
  } catch (error) {
    state.error = 'Erreur lors du chargement des codes promo'
    // En cas d'erreur, initialiser avec un tableau vide
    state.promoCodes = []
  } finally {
    state.isLoading = false
  }
}

const addPromoCode = async (promoData: CreatePromoCodeInput) => {
  state.isLoading = true
  state.error = null
  
  try {
    const vendeurId = authStore.user?.id_vendeur
    
    if (!vendeurId) {
      state.error = 'Utilisateur non connecté'
      return
    }
    
    const newPromo = await createPromoCode(promoData, vendeurId)
    state.promoCodes.unshift(newPromo)
  } catch (error) {
    state.error = 'Erreur lors de l\'ajout du code promo'
  } finally {
    state.isLoading = false
  }
}

const handleDeletePromoCode = async (row: PromoCode) => {
  state.isLoading = true
  state.error = null
  
  try {
    await deletePromoCodeApi(row.id)
    
    const index = state.promoCodes.findIndex(promo => promo.id === row.id)
    if (index !== -1) {
      state.promoCodes.splice(index, 1)
    }
  } catch (error) {
    state.error = 'Erreur lors de la suppression du code promo'
  } finally {
    state.isLoading = false
  }
}

const handleTogglePromoCodeStatus = async (row: PromoCode) => {
  try {
    const isCurrentlyActive = row.actif === 'activé'
    const newStatus = !isCurrentlyActive
    
    await togglePromoCodeStatusApi(row.id, newStatus)
    
    // Mettre à jour l'état local
    row.actif = newStatus ? 'activé' : 'désactivé'
  } catch (err) {
    // Erreur silencieuse pour le changement de statut
  }
}
// UI State
const showAddModal = ref(false)
const showViewModal = ref(false)
const previewHtml = ref<string>('')
const previewLoading = ref(false)
const previewError = ref<string>('')
const showTemplateModal = ref(false)
const showDuplicateModal = ref(false)
const duplicateMessage = ref('Ce code promo existe déjà. Veuillez choisir un autre nom.')
const selectedLanguage = ref('fr')
const referralCode = ref('EFP10-FDARO')
const selectedPromoCode = ref<PromoCode | null>(null)
const isAddingPromo = ref(false)

// Langues disponibles pour le template
const languages = [
  { code: 'fr', name: 'Français' },
  { code: 'en', name: 'Anglais' },
  { code: 'es', name: 'Espagnol' },
  { code: 'it', name: 'Italien' }
]

// Méthodes UI
const openAddPromoModal = () => {
  showAddModal.value = true
}

const handleAddPromoCode = async (formData: Record<string, any>) => {
  try {
    // Duplicate name restriction: prevent adding code with same name (case-insensitive, trimmed)
    const newCode = String(formData.code || '').trim().toLowerCase()
    const exists = state.promoCodes.some(pc => String(pc.code || '').trim().toLowerCase() === newCode)
    if (exists) {
      duplicateMessage.value = 'Ce code promo existe déjà. Veuillez choisir un autre nom.'
      showDuplicateModal.value = true
      return
    }

    isAddingPromo.value = true
    
    const type = formData.type === 'percentage' ? 'Percentage' : 'Reduction'
    const montant = parseFloat(formData.montant) || 0
    const montantMin = parseFloat(formData.montantMin) || 0
    
    const promoData: CreatePromoCodeInput = {
      code: formData.code || '',
      acheteur: formData.acheteur || 'tous',
      type: type as 'Percentage' | 'Reduction',
      montant: type === 'Percentage' ? `${montant.toFixed(2)}%` : `${montant.toFixed(2)}€`,
      montantMin: montantMin === 0 ? '0' : montantMin.toFixed(2),
      localisation: formData.localisation || '1',
      utilisation: (formData.utilisation as 'unique' | 'multiple') || 'unique',
      actif: formData.actif === 'true' ? 'activé' : 'désactivé',
      dateDebut: formData.dateDebut || new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
      dateFin: formData.dateFin || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
      premiereCommande: formData.premiereCommande || false,
      offert: formData.offert || false,
      cumulable: formData.cumulable !== undefined ? formData.cumulable : true
    }
    
    
    await addPromoCode(promoData)
    showAddModal.value = false
  } catch (err) {
    // Erreur gérée par addPromoCode
  } finally {
    isAddingPromo.value = false
  }
}


const copyReferralCode = async () => {
  try {
    await navigator.clipboard.writeText(referralCode.value)
  } catch (error) {
    // Erreur silencieuse pour la copie
  }
}

const viewTemplate = () => {
  showTemplateModal.value = true
}

const viewPromoCode = async (row: PromoCode) => {
  selectedPromoCode.value = row
  showViewModal.value = true
  previewLoading.value = true
  previewError.value = ''
  previewHtml.value = ''

  try {
    const buyerFirstName = (row.acheteur || '').split(' ')[0] || 'Client'
    const sellerName = authStore.user?.nomBoutique || 'Votre grossiste'
    // Conserver les décimales pour éviter des erreurs comme 1.05% → 105%
    const montantStr = String(row.montant)
    const montantMatch = montantStr.match(/\d+(?:[.,]\d+)?/)
    const montantLabel = (montantMatch ? montantMatch[0] : '').replace(',', '.')
    const discountLabel = row.type === 'Percentage'
      ? `-${montantLabel}%`
      : `${montantLabel}€`
    const promoCode = row.code
    const endDate = row.dateFin || '—'
    const catalogueUrl = window.location.origin

    previewHtml.value = await getPromoEmailPreview({
      buyerFirstName,
      sellerName,
      discountLabel,
      promoCode,
      endDate,
      catalogueUrl,
    })
  } catch (e: any) {
    previewError.value = e?.message || 'Impossible de générer l\'aperçu pour le moment.'
  } finally {
    previewLoading.value = false
  }
}

onMounted(async() => {

  if (!authStore.isInitialized) {
    await authStore.checkAuth()
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: 'auth' })
    return
  }
  fetchPromoCodes()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageHeader), {
      title: "Gestion des codes promo",
      subtitle: "Gérez vos codes promotionnels et parrainage",
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ReferralCodeSection), {
        "referral-code": referralCode.value,
        onCopy: copyReferralCode,
        onViewTemplate: viewTemplate
      }, null, 8, ["referral-code"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ActionButton), {
            label: "Ajouter un code promo",
            icon: "fas fa-plus",
            variant: "primary",
            onClick: openAddPromoModal
          }),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-black font-medium" }, ": Codes promotionnels personnalisés", -1))
        ])
      ]),
      (state.promoCodes.length === 0 && !state.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Aucun code promo trouvé "))
        : (state.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Chargement... "))
          : (_openBlock(), _createBlock(_unref(PromoCodeTable), {
              key: 2,
              "promo-codes": state.promoCodes,
              onDelete: handleDeletePromoCode,
              onToggleStatus: handleTogglePromoCodeStatus,
              onView: viewPromoCode
            }, null, 8, ["promo-codes"])),
      _createVNode(_unref(AddPromoModal), {
        "is-visible": showAddModal.value,
        "is-submitting": isAddingPromo.value,
        "onUpdate:isVisible": _cache[0] || (_cache[0] = ($event: any) => (showAddModal.value = $event)),
        onSubmit: handleAddPromoCode
      }, null, 8, ["is-visible", "is-submitting"]),
      _createVNode(_unref(ModalComp), {
        isVisible: showViewModal.value,
        title: "Aperçu de l'email promotionnel",
        size: "xl",
        hideFooter: true,
        "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (showViewModal.value = $event))
      }, {
        body: _withCtx(() => [
          (previewLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Chargement de l'aperçu…"))
            : (previewError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(previewError.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("iframe", {
                      class: "w-full preview-iframe",
                      style: { height: '80vh' },
                      srcdoc: previewHtml.value
                    }, null, 8, _hoisted_11)
                  ]),
                  (selectedPromoCode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center gap-2 mb-4 text-black font-semibold" }, [
                          _createElementVNode("i", { class: "fas fa-cog text-black" }),
                          _createTextVNode(" Informations techniques ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center" }, [
                              _createElementVNode("i", { class: "fas fa-calendar-plus text-black text-sm" })
                            ], -1)),
                            _createElementVNode("div", null, [
                              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs text-black" }, "Date de création", -1)),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(selectedPromoCode.value.dateCreation), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas", selectedPromoCode.value.cumulable ? 'fa-link text-blue-600' : 'fa-unlink text-black'])
                              }, null, 2)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-xs text-black" }, "Cumulable", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["font-semibold", selectedPromoCode.value.cumulable ? 'text-blue-700' : 'text-black'])
                              }, _toDisplayString(selectedPromoCode.value.cumulable ? 'Oui' : 'Non'), 3)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-9 h-9 bg-green-100 rounded-full flex items-center justify-center" }, [
                              _createElementVNode("i", { class: "fas fa-user-plus text-green-600 text-sm" })
                            ], -1)),
                            _createElementVNode("div", null, [
                              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-xs text-black" }, "Première commande", -1)),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(selectedPromoCode.value.premiereCommande ? 'Oui' : 'Non'), 1)
                            ])
                          ]),
                          (_unref(authStore).isImpersonating)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-9 h-9 bg-purple-100 rounded-full flex items-center justify-center" }, [
                                  _createElementVNode("i", { class: "fas fa-gift text-purple-600 text-sm" })
                                ], -1)),
                                _createElementVNode("div", null, [
                                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-xs text-black" }, "Offert", -1)),
                                  _createElementVNode("div", _hoisted_21, _toDisplayString(selectedPromoCode.value.offert ? 'Oui' : 'Non'), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
        ]),
        _: 1
      }, 8, ["isVisible"]),
      _createVNode(_unref(ModalComp), {
        isVisible: showTemplateModal.value,
        title: "Aperçu du template",
        size: "xl",
        "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showTemplateModal.value = false))
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("nav", _hoisted_24, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (lang) => {
                  return _createElementVNode("button", {
                    key: lang.code,
                    onClick: ($event: any) => (selectedLanguage.value = lang.code),
                    class: _normalizeClass([
                    'py-2 px-1 border-b-2 font-medium text-sm',
                    selectedLanguage.value === lang.code
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-black hover:text-black hover:border-gray-300'
                  ])
                  }, _toDisplayString(lang.name), 11, _hoisted_25)
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            (selectedLanguage.value === 'fr')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Template Français", -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("p", _hoisted_29, [
                      _cache[14] || (_cache[14] = _createTextVNode(" Bonjour,")),
                      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                      _cache[17] || (_cache[17] = _createTextVNode(" Je vous propose une offre exclusive avec le code ")),
                      _createElementVNode("strong", null, _toDisplayString(referralCode.value), 1),
                      _cache[18] || (_cache[18] = _createTextVNode(" qui vous donne -10% sur votre première commande chez Efashion Paris.")),
                      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                      _cache[21] || (_cache[21] = _createTextVNode(" Ce code est valable à vie pour votre première commande.")),
                      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                      _cache[24] || (_cache[24] = _createTextVNode(" Cordialement "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedLanguage.value === 'en')
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "English Template", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, [
                      _cache[26] || (_cache[26] = _createTextVNode(" Hello,")),
                      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                      _cache[29] || (_cache[29] = _createTextVNode(" I'm offering you an exclusive deal with code ")),
                      _createElementVNode("strong", null, _toDisplayString(referralCode.value), 1),
                      _cache[30] || (_cache[30] = _createTextVNode(" which gives you -10% on your first order at Efashion Paris.")),
                      _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                      _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                      _cache[33] || (_cache[33] = _createTextVNode(" This code is valid for life for your first order.")),
                      _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                      _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                      _cache[36] || (_cache[36] = _createTextVNode(" Best regards "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedLanguage.value === 'es')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _cache[49] || (_cache[49] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Plantilla Española", -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("p", _hoisted_35, [
                      _cache[38] || (_cache[38] = _createTextVNode(" Hola,")),
                      _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                      _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
                      _cache[41] || (_cache[41] = _createTextVNode(" Te ofrezco una oferta exclusiva con el código ")),
                      _createElementVNode("strong", null, _toDisplayString(referralCode.value), 1),
                      _cache[42] || (_cache[42] = _createTextVNode(" que te da -10% en tu primer pedido en Efashion Paris.")),
                      _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                      _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                      _cache[45] || (_cache[45] = _createTextVNode(" Este código es válido de por vida para tu primer pedido.")),
                      _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                      _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                      _cache[48] || (_cache[48] = _createTextVNode(" Saludos cordiales "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedLanguage.value === 'it')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _cache[61] || (_cache[61] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Template Italiano", -1)),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("p", _hoisted_38, [
                      _cache[50] || (_cache[50] = _createTextVNode(" Ciao,")),
                      _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                      _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                      _cache[53] || (_cache[53] = _createTextVNode(" Ti offro un'offerta esclusiva con il codice ")),
                      _createElementVNode("strong", null, _toDisplayString(referralCode.value), 1),
                      _cache[54] || (_cache[54] = _createTextVNode(" che ti dà -10% sul tuo primo ordine su Efashion Paris.")),
                      _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
                      _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
                      _cache[57] || (_cache[57] = _createTextVNode(" Questo codice è valido a vita per il tuo primo ordine.")),
                      _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
                      _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
                      _cache[60] || (_cache[60] = _createTextVNode(" Cordiali saluti "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["isVisible"]),
      _createVNode(_unref(ModalComp), {
        isVisible: showDuplicateModal.value,
        title: "Attention",
        alert: duplicateMessage.value,
        size: "sm",
        "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showDuplicateModal.value = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showDuplicateModal.value = false))
          }, " OK ")
        ]),
        _: 1
      }, 8, ["isVisible", "alert"])
    ])
  ]))
}
}

})